import { render, staticRenderFns } from "./TaskCustomFields.vue?vue&type=template&id=6b7f7c44&"
import script from "./TaskCustomFields.vue?vue&type=script&lang=js&"
export * from "./TaskCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports